export enum FirmwareUpdateSearchMode {
  SearchByWallBoxName,
  SearchByNetworkId,
  SearchByDeviceProfileId,
  SearchAll,
}
